<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-if="!hideButton" v-slot:activator="{ props }">
      <v-btn
        color="primary"
        :class="{ 'float-right': floatRight, 'mx-2': floatRight }"
        v-bind="props"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        Novo produto
      </v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary" :title="toolbarTitle">
        <v-btn color="black" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <FormProduct
          v-model="value"
          :user="user"
          :categories="categories"
          @created="createdObject"
          @updated="updatedObject"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" @click="dialog = false">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FormProduct from './FormProduct.vue'

export default {
  components: { FormProduct },
  props: {
    user: Object,
    modelValue: Object,
    floatRight: Boolean,
    hideButton: Boolean,
    categories: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue', 'created', 'updated'],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    createdObject(val) {
      this.dialog = false
      this.$emit('created', val)
    },
    updatedObject(val) {
      this.dialog = false
      this.$emit('updated', val)
    },
  },
  computed: {
    toolbarTitle() {
      return this.modelValue?.id ? 'Editar produto' : 'Novo produto'
    },
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal && newVal.id && !this.dialog) {
        this.dialog = true
      }
    },
    dialog(newVal) {
      if (!newVal) {
        this.value = {}
      }
    },
  },
}
</script>
